import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { useIsMobileDetect } from "../../hooks";
import { useSignalR } from "../../hooks/SignalR/SignalRContext";
import { GamepadControl } from "../GamepadControl/GamepadControl";
/*const STOP_REPEAT_COUNT = 10;
const STOP_REPEAT_INTERVAL_MS = 50;*/
export const OperatorActionsHandler = ({ children, isArmed, onGoForward, onGoBackward, onStop, onTurnLeft, onTurnRight, onEndTurnLeft, onEndTurnRight, onSpotTurnLeft, onSpotTurnRight, onForceForward, onForceBackward, onStopForceForward, onStopForceBackward, onArmedStateChanged, onControlTypeChanged, stickPositions, mobileActiveRef, keyboardActiveRef, isStickSend, cruiseGasRef, keyboardGasRef, onCruiseStop, }) => {
    const validKeys = [
        "ArrowLeft",
        "ArrowUp",
        "ArrowRight",
        "ArrowDown",
        "KeyA",
        "KeyD",
        "KeyS",
        "KeyW",
        "Digit1",
        "Digit2",
        "Digit3",
        "Digit4",
        "Space",
    ];
    const [controlType, setControlType] = useState(false);
    const ControlContext = React.createContext({ armedState: 0, controlType: true });
    const controlConnection = useSignalR();
    const pressedKeys = useRef(new Set());
    const repeatAfterMs = 40;
    const commandTimer = useRef(null);
    const isArmedRef = useRef(isArmed);
    const channels = useRef([0, 0, 0, 0, 0, 1, 0]);
    const currentPower = useRef(0.25);
    const POWER_CHANNEL = 2;
    const TURN_CHANNEL = 3;
    const wasCruiseRef = useRef(false);
    const wasCommandCruiseRef = useRef(false);
    const isStickSendRef = useRef(isStickSend);
    isStickSendRef.current = isStickSend;
    //const stopSequenceTimers = useRef<NodeJS.Timeout[]>([]);
    useEffect(() => {
        document.body.addEventListener("keydown", keyDown);
        return () => {
            document.body.removeEventListener("keydown", keyDown);
        };
    });
    useEffect(() => {
        document.body.addEventListener("keyup", keyUp);
        return () => {
            document.body.removeEventListener("keyup", keyUp);
        };
    });
    useEffect(() => {
        isArmedRef.current = isArmed;
    }, [isArmed]);
    const isCruise = () => !!cruiseGasRef && cruiseGasRef.current !== null;
    const cruiseGo = () => {
        if (!controlConnection ||
            isStickSendRef.current ||
            !cruiseGasRef ||
            cruiseGasRef.current === null) {
            return;
        }
        const value = isArmedRef.current < 0 ? 0 : Math.abs(cruiseGasRef.current);
        if (cruiseGasRef.current >= 0) {
            controlConnection.invoke("GoForward", value);
            if (onGoForward) {
                onGoForward();
            }
        }
        else {
            controlConnection.invoke("GoBackward", value);
            if (onGoBackward) {
                onGoBackward();
            }
        }
    };
    /*useEffect(() => {
      return () => {
        stopSequenceTimers.current.forEach(clearTimeout);
        stopSequenceTimers.current = [];
      };
    }, []);*/
    /*const cancelStopSequence = () => {
      stopSequenceTimers.current.forEach(clearTimeout);
      stopSequenceTimers.current = [];
    };*/
    /*const invokeStopRepeatedly = () => {
      cancelStopSequence();
      if (!controlConnection && isArmed !== -1) return;
      for (let i = 0; i < STOP_REPEAT_COUNT; i++) {
        const timer = setTimeout(() => {
          if (controlConnection) {
            console.log("Stop");
            controlConnection.invoke("Stop");
          }
        }, i * STOP_REPEAT_INTERVAL_MS);
        stopSequenceTimers.current.push(timer);
      }
    };*/
    useEffect(() => {
        const handleFocusLoss = () => {
            channels.current = [0, 0, 0, 0, 0, 1, 0];
            const hadTurnLeft = pressedKeys.current.has("ArrowLeft");
            const hadTurnRight = pressedKeys.current.has("ArrowRight");
            const hadForceForward = pressedKeys.current.has("KeyW");
            const hadForceBackward = pressedKeys.current.has("KeyS");
            const hadAny = pressedKeys.current.size > 0;
            pressedKeys.current.clear();
            if (!hadAny || isArmedRef.current >= 0)
                return;
            if (hadTurnLeft) {
                endTurnLeft();
            }
            else if (hadTurnRight) {
                endTurnRight();
            }
            else if (hadForceForward) {
                stopForceForward();
            }
            else if (hadForceBackward) {
                stopForceBackward();
            }
            else {
                stop();
            }
        };
        const handleVisibilityChange = () => {
            if (document.hidden)
                handleFocusLoss();
        };
        window.addEventListener("blur", handleFocusLoss);
        window.addEventListener("pagehide", handleFocusLoss);
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            window.removeEventListener("blur", handleFocusLoss);
            window.removeEventListener("pagehide", handleFocusLoss);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [controlConnection]);
    const goForward = (value) => {
        //cancelStopSequence();
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("GoForward", value);
            if (onGoForward) {
                onGoForward();
            }
        }
    };
    const stop = () => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("Stop");
            if (onStop) {
                onStop();
            }
        }
    };
    const turnLeft = (turnRate = null, power = null) => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("TurnLeft", turnRate, power);
            if (onTurnLeft) {
                onTurnLeft();
            }
        }
    };
    const turnRight = (turnRate = null, power = null) => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("TurnRight", turnRate, power);
            if (onTurnRight) {
                onTurnRight();
            }
        }
    };
    const goBackward = (value) => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("GoBackward", value);
            if (onGoBackward) {
                onGoBackward();
            }
        }
    };
    const endTurnLeft = (power = null) => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("EndTurnLeft", power);
            if (onEndTurnLeft) {
                onEndTurnLeft();
            }
        }
    };
    const endTurnRight = (power = null) => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("EndTurnRight", power);
            if (onEndTurnRight) {
                onEndTurnRight();
            }
        }
    };
    const spotTurnLeft = (power = null) => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("SpotTurnLeft", power);
            if (onSpotTurnLeft) {
                onSpotTurnLeft();
            }
        }
    };
    const spotTurnRight = (power = null) => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("SpotTurnRight", power);
            if (onSpotTurnRight) {
                onSpotTurnRight();
            }
        }
    };
    const forceForward = () => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("ForceForward");
            if (onForceForward) {
                onForceForward();
            }
        }
    };
    const forceBackward = () => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("ForceBackward");
            if (onForceBackward) {
                onForceBackward();
            }
        }
    };
    const stopForceForward = () => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("Stop");
            if (onStopForceForward) {
                onStopForceForward();
            }
        }
    };
    const stopForceBackward = () => {
        if (controlConnection && !isStickSendRef.current) {
            controlConnection.invoke("Stop");
            if (onStopForceBackward) {
                onStopForceBackward();
            }
        }
    };
    const sendChannels = (channels) => {
        if (controlConnection && isStickSendRef.current) {
            controlConnection.invoke("StickPositions", channels);
        }
    };
    const keyDown = (e) => {
        if (e.repeat || validKeys.indexOf(e.code) === -1 || isArmed >= 0) {
            return;
        }
        e.preventDefault();
        if (e.code === "Space") {
            stop();
            if (onCruiseStop) {
                onCruiseStop();
            }
        }
        else if (e.code === "Digit1") {
            currentPower.current = 0.25;
            controlConnection.invoke("Speed", 25);
        }
        else if (e.code === "Digit2") {
            currentPower.current = 0.5;
            controlConnection.invoke("Speed", 50);
        }
        else if (e.code === "Digit3") {
            currentPower.current = 0.75;
            controlConnection.invoke("Speed", 75);
        }
        else if (e.code === "Digit4") {
            currentPower.current = 1;
            controlConnection.invoke("Speed", 100);
        }
        else {
            //cancelStopSequence();
            pressedKeys.current.add(e.code);
            if (e.code === "ArrowLeft") {
                if (pressedKeys.current.has("ArrowUp") ||
                    pressedKeys.current.has("ArrowDown") ||
                    isCruise()) {
                    turnLeft();
                }
                else {
                    spotTurnLeft();
                }
            }
            else if (e.code === "ArrowRight") {
                if (pressedKeys.current.has("ArrowUp") ||
                    pressedKeys.current.has("ArrowDown") ||
                    isCruise()) {
                    turnRight();
                }
                else {
                    spotTurnRight();
                }
            }
            else if (e.code === "ArrowDown") {
                goBackward(0);
            }
            else if (e.code === "ArrowUp") {
                goForward(0);
            }
            else if (e.code === "KeyA") {
                spotTurnLeft();
            }
            else if (e.code === "KeyD") {
                spotTurnRight();
            }
            else if (e.code === "KeyW") {
                forceForward();
            }
            else if (e.code === "KeyS") {
                forceBackward();
            }
        }
    };
    const isMobilePortrait = useIsMobileDetect();
    const isMobilePortraitRef = useRef(isMobilePortrait);
    isMobilePortraitRef.current = isMobilePortrait;
    useEffect(() => {
        commandTimer.current = setInterval(() => {
            if (pressedKeys.current.size === 0) {
                if (isArmedRef.current === -1 &&
                    controlConnection &&
                    !isMobilePortraitRef.current &&
                    (!cruiseGasRef || cruiseGasRef.current === null)) {
                    controlConnection.invoke("Stop");
                }
                //return;
            }
            if (pressedKeys.current.has("ArrowUp") &&
                pressedKeys.current.has("ArrowLeft")) {
                channels.current[TURN_CHANNEL] = -1;
                channels.current[POWER_CHANNEL] = currentPower.current;
                console.log("ArrowLeft ArrowUp");
                turnLeft();
            }
            else if (pressedKeys.current.has("ArrowUp") &&
                pressedKeys.current.has("ArrowRight")) {
                channels.current[TURN_CHANNEL] = 1;
                channels.current[POWER_CHANNEL] = currentPower.current;
                console.log("ArrowRight ArrowUp");
                turnRight();
            }
            else if (pressedKeys.current.has("ArrowDown") &&
                pressedKeys.current.has("ArrowLeft")) {
                channels.current[TURN_CHANNEL] = -1;
                channels.current[POWER_CHANNEL] = -currentPower.current;
                console.log("ArrowLeft ArrowDown");
                turnRight();
            }
            else if (pressedKeys.current.has("ArrowDown") &&
                pressedKeys.current.has("ArrowRight")) {
                channels.current[TURN_CHANNEL] = 1;
                channels.current[POWER_CHANNEL] = -currentPower.current;
                console.log("ArrowRight ArrowDown");
                turnLeft();
            }
            else if (pressedKeys.current.has("ArrowLeft")) {
                channels.current[TURN_CHANNEL] = -1;
                console.log("ArrowLeft");
                //turnLeft();
                if (isCruise()) {
                    turnLeft();
                }
                else {
                    spotTurnLeft();
                }
            }
            else if (pressedKeys.current.has("ArrowRight")) {
                channels.current[TURN_CHANNEL] = 1;
                console.log("ArrowRight");
                //turnRight();
                if (isCruise()) {
                    turnRight();
                }
                else {
                    spotTurnRight();
                }
            }
            else if (pressedKeys.current.has("ArrowDown")) {
                channels.current[POWER_CHANNEL] = -currentPower.current;
                console.log("ArrowDown");
                goBackward(0);
            }
            else if (pressedKeys.current.has("ArrowUp")) {
                channels.current[POWER_CHANNEL] = currentPower.current;
                goForward(0);
            }
            else if (pressedKeys.current.has("KeyA")) {
                channels.current[TURN_CHANNEL] = -currentPower.current;
                spotTurnLeft();
            }
            else if (pressedKeys.current.has("KeyD")) {
                channels.current[TURN_CHANNEL] = currentPower.current;
                spotTurnRight();
            }
            else if (pressedKeys.current.has("KeyW")) {
                channels.current[POWER_CHANNEL] = 1;
                forceForward();
            }
            else if (pressedKeys.current.has("KeyS")) {
                channels.current[POWER_CHANNEL] = -1;
                forceBackward();
            }
            if (keyboardActiveRef) {
                keyboardActiveRef.current = pressedKeys.current.size > 0;
            }
            if (keyboardGasRef) {
                keyboardGasRef.current =
                    pressedKeys.current.has("ArrowUp") ||
                        pressedKeys.current.has("ArrowDown")
                        ? channels.current[POWER_CHANNEL]
                        : null;
            }
            const isCruiseNow = isCruise();
            if (wasCruiseRef.current && !isCruiseNow) {
                const stopChannels = [...channels.current];
                stopChannels[POWER_CHANNEL] = 0;
                stopChannels[TURN_CHANNEL] = 0;
                sendChannels(stopChannels);
            }
            wasCruiseRef.current = isCruiseNow && isArmedRef.current < 0;
            if (wasCommandCruiseRef.current &&
                !isCruiseNow &&
                controlConnection &&
                !isStickSendRef.current) {
                controlConnection.invoke("Stop");
            }
            wasCommandCruiseRef.current = isCruiseNow && !isStickSendRef.current;
            if (isArmedRef.current < 0 &&
                isCruiseNow &&
                !["ArrowLeft", "ArrowRight", "KeyA", "KeyD", "KeyW", "KeyS"].some((key) => pressedKeys.current.has(key))) {
                cruiseGo();
            }
            if (isArmedRef.current < 0 && !(mobileActiveRef === null || mobileActiveRef === void 0 ? void 0 : mobileActiveRef.current)) {
                if (cruiseGasRef && cruiseGasRef.current !== null) {
                    const cruiseChannels = [...channels.current];
                    cruiseChannels[POWER_CHANNEL] = cruiseGasRef.current;
                    sendChannels(cruiseChannels);
                }
                else {
                    sendChannels(channels.current);
                }
            }
        }, repeatAfterMs);
        return () => clearInterval(commandTimer.current);
    }, [controlConnection]);
    const keyUp = (e) => {
        e.preventDefault();
        pressedKeys.current.delete(e.code);
        if (isArmed >= 0 && e.code !== "KeyO") {
            channels.current[POWER_CHANNEL] = 0;
            channels.current[TURN_CHANNEL] = 0;
            return;
        }
        if (e.code === "ArrowUp") {
            channels.current[POWER_CHANNEL] = 0;
            if (isCruise()) {
                return;
            }
            if (pressedKeys.current.has("ArrowLeft")) {
                endTurnLeft();
            }
            else if (pressedKeys.current.has("ArrowRight")) {
                endTurnRight();
            }
            else {
                stop();
            }
            return;
        }
        if (e.code === "ArrowLeft") {
            channels.current[TURN_CHANNEL] = 0;
            if (pressedKeys.current.has("ArrowUp") || isCruise()) {
                endTurnLeft();
            }
            else {
                stop();
            }
            return;
        }
        if (e.code === "ArrowRight") {
            channels.current[TURN_CHANNEL] = 0;
            if (pressedKeys.current.has("ArrowUp") || isCruise()) {
                endTurnRight();
            }
            else {
                stop();
            }
            return;
        }
        if (e.code === "ArrowDown") {
            channels.current[POWER_CHANNEL] = 0;
            if (isCruise()) {
                return;
            }
            if (pressedKeys.current.has("ArrowLeft")) {
                endTurnRight();
            }
            else if (pressedKeys.current.has("ArrowRight")) {
                endTurnLeft();
            }
            else {
                stop();
            }
            return;
        }
        if (e.code === "KeyA") {
            channels.current[TURN_CHANNEL] = 0;
            if (!isCruise()) {
                stop();
            }
            //return;
        }
        if (e.code === "KeyD") {
            channels.current[TURN_CHANNEL] = 0;
            if (!isCruise()) {
                stop();
            }
            //return;
        }
        if (e.code === "KeyW") {
            channels.current[POWER_CHANNEL] = 0;
            stopForceForward();
            //return;
        }
        if (e.code === "KeyS") {
            channels.current[POWER_CHANNEL] = 0;
            stopForceBackward();
            //return;
        }
        if (e.code === "KeyO") {
            if (isArmed < 0) {
                onArmedStateChanged(0);
                return;
            }
            if (isArmed === 0) {
                onArmedStateChanged(-1);
                return;
            }
            onArmedStateChanged(isArmed);
            return;
        }
    };
    const onGo = (value, direction) => {
        if (isCruise()) {
            cruiseGo();
            return;
        }
        if (direction) {
            goForward(value);
        }
        else {
            goBackward(value);
        }
    };
    const onDroneStop = () => {
        if (isCruise()) {
            cruiseGo();
            return;
        }
        stop();
    };
    const onTurn = (direction, isSpot, turnRate, power) => {
        const turnPower = isCruise() ? cruiseGasRef.current : power;
        if (direction) {
            if (isSpot) {
                spotTurnRight(turnRate);
            }
            else {
                turnRight(turnRate, turnPower);
            }
        }
        else {
            if (isSpot) {
                spotTurnLeft(turnRate);
            }
            else {
                turnLeft(turnRate, turnPower);
            }
        }
    };
    const onEndTurn = (direction, isSpot, power) => {
        const turnPower = isCruise() ? cruiseGasRef.current : power;
        if (isSpot) {
            if (isCruise()) {
                cruiseGo();
            }
            else {
                stop();
            }
        }
        else {
            if (direction) {
                endTurnRight(turnPower);
            }
            else {
                endTurnLeft(turnPower);
            }
        }
    };
    const rightForward = (value) => {
        if (controlConnection) {
            controlConnection.invoke("RightForward", value);
        }
    };
    const leftForward = (value) => {
        if (controlConnection) {
            controlConnection.invoke("LeftForward", value);
        }
    };
    const rightBackard = (value) => {
        if (controlConnection) {
            controlConnection.invoke("RightBackward", value);
        }
    };
    const leftBackward = (value) => {
        if (controlConnection) {
            controlConnection.invoke("LeftBackward", value);
        }
    };
    const rightStop = () => {
        if (controlConnection) {
            controlConnection.invoke("RightStop");
        }
    };
    const leftStop = () => {
        if (controlConnection) {
            controlConnection.invoke("LeftStop");
        }
    };
    const onArmedStatusChanged = (status) => {
        stop();
        if (onArmedStateChanged) {
            onArmedStateChanged(status);
        }
    };
    const onDriveTypeChanged = (type) => {
        setControlType(type);
        if (onControlTypeChanged) {
            onControlTypeChanged(type);
        }
    };
    const relayStateChanged = (channel, value) => {
        if (controlConnection) {
            controlConnection.invoke("SwitchRelay", channel, Math.round(value));
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(GamepadControl, { rightForwardCb: rightForward, rightBackwardCb: rightBackard, rightStopCb: rightStop, leftStopCb: leftStop, leftForwardCb: leftForward, leftBackwardCb: leftBackward, onArmedStatusChanged: onArmedStatusChanged, onControlTypeChanged: onDriveTypeChanged, goCb: onGo, stopCb: onDroneStop, turnCb: onTurn, endTurnCb: onEndTurn, onRelayStateChanged: relayStateChanged, stickPositionsCb: stickPositions }), _jsx(ControlContext.Provider, { value: { armedState: isArmed, controlType: controlType }, children: children })] }));
};
